<div class="offer-compare-box">
    <span *ngIf="icon" class="material-icons" [class.icon-none]="icon === '—'" [class.check]="icon === 'check'" [class.icon-close]="icon === 'close'">
        {{icon}}
    </span>
    <span *ngIf="!this.icon">
        <ng-container *ngIf="isValueAmount; else notAmount" >
            {{ optionValue | separator }} {{ 'OFFER_SECTION.SHARED.currencyShortcut' | translate }}
        </ng-container>
        <ng-template #notAmount>
            {{ optionValue }}
        </ng-template>
    </span>
</div>
